import React from 'react'
import { Outlet } from 'react-router-dom'

const PlacementCareer = () => {
  return (
    <>
    <Outlet />
    </>
  )
}

export default PlacementCareer